import type { Track } from "@similarweb/tracking-provider";
import type { CustomAttributes } from "app/services/track/track";

const createManagementTrackingService = (track: Track) => {
    const trackSignalApiEvent = (action: string, eventName: string, customAttributes?: CustomAttributes): void => {
        track("signals API", action, eventName, customAttributes);
    };

    const trackLeadEnrichmentApiEvent = (
        action: string,
        eventName: string,
        customAttributes?: CustomAttributes,
    ): void => {
        track("lead enrichment API", action, eventName, customAttributes);
    };

    const trackContactsApiEvent = (action: string, eventName: string, customAttributes?: CustomAttributes): void => {
        track("contacts API", action, eventName, customAttributes);
    };

    const trackSignalApiHook = (eventName: string, customAttributes?: CustomAttributes) => {
        track("SI Hooks", "click", eventName, customAttributes);
    };

    const trackAiOutreachApiEvent = (action: string, eventName: string, customAttributes?: CustomAttributes): void => {
        track("ai outreach API", action, eventName, customAttributes);
    };

    const trackSignalApiClickEvent = (eventName: string, customAttributes?: CustomAttributes) => {
        trackSignalApiEvent("click", eventName, customAttributes);
    };

    const trackContactsApiClickEvent = (eventName: string, customAttributes?: CustomAttributes) => {
        trackContactsApiEvent("clicked", eventName, customAttributes);
    };

    const trackLeadEnrichmentApiClickEvent = (eventName: string, customAttributes?: CustomAttributes) => {
        trackLeadEnrichmentApiEvent("click", eventName, customAttributes);
    };

    const trackAiOutreachApiClickEvent = (eventName: string, customAttributes?: CustomAttributes) => {
        trackAiOutreachApiEvent("click", eventName, customAttributes);
    };

    return {
        trackSignalApiEvent,
        trackSignalApiHook,
        trackSignalApiClickEvent,
        trackContactsApiClickEvent,
        trackLeadEnrichmentApiClickEvent,
        trackAiOutreachApiEvent,
        trackAiOutreachApiClickEvent,
    };
};

export default createManagementTrackingService;
